import Vue from 'vue';
import { storeGet } from '@/store/store-utils';

// Valid tab types matching the backend
const VALID_TYPES = ['gldata', 'drilldown', 'masters'];

export default {
    namespaced: true,

    state: {},
    getters: {},
    mutations: {},

    actions: {
        /**
         * Fetch data processing records for a specific tab type.
         * @param {string} type - 'gldata' | 'drilldown' | 'masters'
         * @returns {Array} raw records from the API
         */
        async fetchTabData({ commit, rootState }, { type } = {}) {
            if (!VALID_TYPES.includes(type)) {
                console.error(`[DataProcessing Store]: Invalid type "${type}"`);
                commit('sbError', `Invalid tab type: ${type}`, { root: true });
                return [];
            }
            try {
                const response = await storeGet(Vue.axios, rootState, '/v2/varianceanalysis/dataprocessing/get', { type });
                if (response.data.status === 'success') {
                    return response.data.data || [];
                } else {
                    throw new Error('Error reading data');
                }
            } catch (error) {
                console.error('[DataProcessing Store]: fetchTabData error', error);
                commit('sbError', error.message || error || 'Unknown error!', { root: true });
                throw error;
            }
        },
    },
};
